<template>
  <router-view />
</template>

<script>
// const appName = process.env.VUE_APP_NAME;

export default {
  name: "App",
  created() {
    // if (appName == "") {
    //   document.title = "M -";
    // } else {
    //   document.title = appName;
    // }

    //ATUR TITLE APP
    document.title = "Indobeauty";
  },
};
</script>

<style src="./styles/app.scss" lang="scss" />
